import { graphql } from "relay-runtime";

import { useFragment } from "react-relay";
import { useIsSaveable_Routine$key } from "./__generated__/useIsSaveable_Routine.graphql";
import { useRoutineEditState } from "../State/RoutineEditState";
import type { RoutineEditParams } from "../RoutineEditMain/RoutineEditNavigation";

export function useIsSavable(props: {
  routine: useIsSaveable_Routine$key;
  mode: RoutineEditParams["mode"];
}): boolean {
  const routineState = useRoutineEditState();
  const routine = useFragment(
    graphql`
      fragment useIsSaveable_Routine on Routine {
        isOrg
        activeVersion {
          connections {
            sectionId
            taskId
          }
        }
      }
    `,
    props.routine
  );

  if (props.mode === "CREATE") {
    const hasTitle = routineState.title ? routineState.title.length > 0 : false;
    return (
      hasTitle &&
      (routineState.controlType === "checklist"
        ? (routineState.tasks?.length ?? 0) > 0
        : true)
    );
  }

  if (routine.isOrg || routineState.controlType === "checklist") {
    const connections =
      routineState.connections ?? routine.activeVersion?.connections ?? [];
    return connections.length > 0;
  }

  return true;
}
